/**
 * 入力値のフォーマット関数群
 */

/**
 * カード番号のフォーマット (4桁区切り)
 * @param {string} value - 入力値
 * @returns {string} フォーマット済みカード番号
 */
export const formatCardNumber = (value) => {
  const cleaned = value.replace(/\D/g, '');
  return cleaned.slice(0, 16).replace(/(\d{4})(?=\d)/g, '$1 ');
};

/**
 * CVVのフォーマット (数字のみ、3-4桁)
 * @param {string} value - 入力値
 * @returns {string} フォーマット済みCVV
 */
export const formatCVV = (value) => {
  return value.replace(/\D/g, '').slice(0, 4);
};

/**
 * カード名義人のフォーマット (英字のみ、大文字変換)
 * @param {string} value - 入力値
 * @returns {string} フォーマット済み名義人名
 */
export const formatCardholderName = (value) => {
  return value.replace(/[^a-zA-Z\s]/g, '').toUpperCase().slice(0, 26);
};

/**
 * 郵便番号のフォーマット (数字とハイフンのみ)
 * @param {string} value - 入力値
 * @returns {string} フォーマット済み郵便番号
 */
export const formatZipCode = (value) => {
  return value.replace(/[^0-9-]/g, '').slice(0, 8);
};

/**
 * 電話番号のフォーマット (数字とハイフンのみ)
 * @param {string} value - 入力値
 * @returns {string} フォーマット済み電話番号
 */
export const formatPhoneNumber = (value) => {
  return value.replace(/[^0-9-]/g, '').slice(0, 13);
};